import { Dispatch, SetStateAction, useState } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { useAppSelector } from 'app/store/store';

export interface mapConfigStateT {
  mapname: string;
}

export interface CheckBoxStateI {
  showECAState: [boolean, Dispatch<SetStateAction<boolean>>];
  showATBAState: [boolean, Dispatch<SetStateAction<boolean>>];
  showNAVAREAState: [boolean, Dispatch<SetStateAction<boolean>>];
  showLLZState: [boolean, Dispatch<SetStateAction<boolean>>];
  showEEZState: [boolean, Dispatch<SetStateAction<boolean>>];
}

export const useGetMapSettingsState = () => {
  const uiconfig = useAppSelector((state) => state.userSlice.uiConfig);

  const showVesselsState = useLocalStorage<boolean>('showVessels', true);
  const showPortsState = useLocalStorage<boolean>('showPorts', false);
  const showSeaMarksState = useLocalStorage<boolean>('showSeaMarks', false);
  const showLegendState = useLocalStorage<boolean>('showLegend', false);
  const showVesselsNamesState = useLocalStorage<boolean>('showVesselsNames', false);
  const showRouteState = useLocalStorage<boolean>('showRoutes', false);
  const showTerminalsState = useLocalStorage<boolean>('showTerminals', false);
  const showAtonsState = useLocalStorage<boolean>('showAtons', false);
  const showRoutePredictedState = useLocalStorage<boolean>('showRoutePredicted', false);
  const showAnchorageState = useLocalStorage<boolean>('showAnchorage', false);

  const showIndicatorState = useState<boolean>(
    localStorage.getItem('showIndicator') === null ? true : localStorage.getItem('showIndicator') === 'true',
  );
  const autoRefreshState = useState<boolean>(
    localStorage.getItem('autoRefresh') === 'true' && uiconfig?.feMapAutoRefreshAvailable ? true : false,
  );
  const mapConfigState = useLocalStorage<mapConfigStateT>('selectedMapType', {
    mapname: window._env_.MAP_DEFAULT,
  });

  const useCheckBoxSpecialAreasState = () => {
    const showECAState = useLocalStorage<boolean>('showECA', false);
    const showATBAState = useLocalStorage<boolean>('showATBA', false);
    const showNAVAREAState = useLocalStorage<boolean>('showNAVAREA', false);
    const showLLZState = useLocalStorage<boolean>('showLLZ', false);
    const showEEZState = useLocalStorage<boolean>('showEEZ', false);
    return {
      showECAState,
      showATBAState,
      showNAVAREAState,
      showLLZState,
      showEEZState,
    };
  };
  const checkBoxSpecialAreasState: CheckBoxStateI = useCheckBoxSpecialAreasState();

  return {
    showVesselsState,
    showAtonsState,
    showPortsState,
    showTerminalsState,
    showSeaMarksState,
    showLegendState,
    showVesselsNamesState,
    showRouteState,
    showRoutePredictedState,
    showIndicatorState,
    autoRefreshState,
    mapConfigState,
    checkBoxSpecialAreasState,
    showAnchorageState,
  };
};
